/**
 * GENERATED FILE — DO NOT EDIT BY HAND.
 *
 * Source of truth: packages/backend/lib/permissions.ts (ROLE_PERMISSIONS).
 * Regenerate:      pnpm gen:permissions
 * Drift gate (CI): pnpm check:permissions-drift  (a drift between the backend
 *                  ROLE_PERMISSIONS and this file FAILS the build — ENG-10 / CC-2).
 *
 * The six firm-level roles + the exact Permission union are mirrored from the
 * backend so the frontend gates UI affordances against the *same* catalogue the
 * server authorises against — no hand-maintained duplicate that can drift.
 */

/** The six firm-level roles (auth-and-authz.md §2.1). */
export type Role =
  | 'managing_partner'
  | 'senior_associate'
  | 'associate'
  | 'paralegal'
  | 'client'
  | 'firm_admin';

/** The exact Permission union (auth-and-authz.md §2.3). */
export type Permission =
  | 'firm.read'
  | 'firm.write'
  | 'firm.billing'
  | 'users.read'
  | 'users.invite'
  | 'users.deactivate'
  | 'cases.list'
  | 'cases.create'
  | 'cases.read'
  | 'cases.write'
  | 'cases.delete'
  | 'cases.archive'
  | 'cases.assign'
  | 'cases.close'
  | 'documents.list'
  | 'documents.upload'
  | 'documents.read'
  | 'documents.delete'
  | 'documents.reocr'
  | 'documents.review'
  | 'findings.list'
  | 'findings.read'
  | 'findings.create'
  | 'findings.suppress'
  | 'findings.resolve'
  | 'reports.list'
  | 'reports.generate'
  | 'reports.read'
  | 'reports.email_client'
  | 'reports.court_bundle'
  | 'reports.sign'
  | 'audit.read'
  | 'audit.export'
  | 'ai.use'
  | 'admin.legal_hold'
  | 'admin.retention_override'
  | 'dsar.read'
  | 'dsar.manage';

/** Every catalogued permission, in canonical order. */
export const ALL_PERMISSIONS: readonly Permission[] = [
  'firm.read',
  'firm.write',
  'firm.billing',
  'users.read',
  'users.invite',
  'users.deactivate',
  'cases.list',
  'cases.create',
  'cases.read',
  'cases.write',
  'cases.delete',
  'cases.archive',
  'cases.assign',
  'cases.close',
  'documents.list',
  'documents.upload',
  'documents.read',
  'documents.delete',
  'documents.reocr',
  'documents.review',
  'findings.list',
  'findings.read',
  'findings.create',
  'findings.suppress',
  'findings.resolve',
  'reports.list',
  'reports.generate',
  'reports.read',
  'reports.email_client',
  'reports.court_bundle',
  'reports.sign',
  'audit.read',
  'audit.export',
  'ai.use',
  'admin.legal_hold',
  'admin.retention_override',
  'dsar.read',
  'dsar.manage',
];

/** The canonical role → permission map (auth-and-authz.md §2.3, verbatim). */
export const ROLE_PERMISSIONS: Record<Role, readonly Permission[]> = {
  managing_partner: [
    'firm.read',
    'firm.write',
    'firm.billing',
    'users.read',
    'users.invite',
    'users.deactivate',
    'cases.list',
    'cases.create',
    'cases.read',
    'cases.write',
    'cases.delete',
    'cases.archive',
    'cases.assign',
    'cases.close',
    'documents.list',
    'documents.upload',
    'documents.read',
    'documents.delete',
    'documents.reocr',
    'documents.review',
    'findings.list',
    'findings.read',
    'findings.create',
    'findings.suppress',
    'findings.resolve',
    'reports.list',
    'reports.generate',
    'reports.read',
    'reports.email_client',
    'reports.court_bundle',
    'reports.sign',
    'audit.read',
    'audit.export',
    'ai.use',
    'admin.legal_hold',
    'admin.retention_override',
    'dsar.read',
    'dsar.manage',
  ],
  senior_associate: [
    'cases.list',
    'cases.create',
    'cases.read',
    'cases.write',
    'cases.archive',
    'cases.assign',
    'cases.close',
    'documents.list',
    'documents.upload',
    'documents.read',
    'documents.reocr',
    'documents.review',
    'findings.list',
    'findings.read',
    'findings.create',
    'findings.suppress',
    'findings.resolve',
    'reports.list',
    'reports.generate',
    'reports.read',
    'reports.email_client',
    'reports.court_bundle',
    'audit.read',
    'ai.use',
  ],
  associate: [
    'cases.list',
    'cases.read',
    'cases.write',
    'documents.list',
    'documents.upload',
    'documents.read',
    'documents.reocr',
    'findings.list',
    'findings.read',
    'findings.create',
    'reports.list',
    'reports.generate',
    'reports.read',
    'audit.read',
    'ai.use',
  ],
  paralegal: [
    'cases.list',
    'cases.read',
    'documents.list',
    'documents.upload',
    'documents.read',
    'documents.reocr',
    'findings.list',
    'findings.read',
    'findings.create',
    'reports.list',
    'reports.read',
    'audit.read',
  ],
  client: [
    'cases.read',
    'documents.list',
    'documents.upload',
    'documents.read',
    'reports.list',
    'reports.read',
  ],
  firm_admin: [
    'firm.read',
    'firm.billing',
    'users.read',
    'users.invite',
    'users.deactivate',
    'audit.read',
  ],
};
